
const TitleSection = ({ title = "Title", subtitle } : { title : string, subtitle? : string }) => {
  return (
    <div className="title-section">
      <div className="wrapper-small">
          <h2>{title}</h2>
          {subtitle ? <p className={`subtitle`}>{subtitle}</p> : ""}
      </div>
    </div>
  )
}

export default TitleSection